import construct from "./methods/construct.js";

export default {
    construct,
};
